import type { ExploreContentItemContentOneOfFivezeroBasicInfoAllOf } from './exploreContentItemContentOneOfFivezeroBasicInfoAllOf';
import type { ExploreContentItemContentOneOfFivezeroBasicInfoAllOfTwo } from './exploreContentItemContentOneOfFivezeroBasicInfoAllOfTwo';

export type ExploreContentItemContentOneOfFivezeroBasicInfo = ExploreContentItemContentOneOfFivezeroBasicInfoAllOf & ExploreContentItemContentOneOfFivezeroBasicInfoAllOfTwo;
